import React from 'react';
import bem from 'utils/bem';
import Page from '../Page';
import Text from 'components/Text';
import GiveCertWidget from 'components/GiveCertWidget';
import BuyConsultationWidget from 'components/BuyConsultationWidget';
import './index.sass';
import { whatsAppContacts } from 'components/AddressAndPhones';

const { block, el } = bem('payment-rules');

const PaymentRules = () => {
    return (
        <Page className={ block() } title={ 'Правила' }>
            <div className={ el('content') }>
                <div className={ el('text') }>
                    <li>
                        <Text>
                            Оплата банковскими картами осуществляется через <b>АО «АЛЬФА-БАНК»</b>.
                        </Text>
                    </li>
                    <li>
                        <Text>
                            К оплате принимаются карты <b>VISA, MasterCard, Платежной системы «Мир»</b>.
                        </Text>
                    </li>
                    <li>
                        <Text>
                            Услуга оплаты через Интернет осуществляется в соответствии с Правилами
                            международных платежных систем <b>Visa, MasterCard</b> и <b>Платежной системы «Мир»</b> на
                            принципах соблюдения конфиденциальности и безопасности совершения платежа,
                            для чего используются самые современные методы проверки, шифрования и
                            передачи данных по закрытым каналам связи. Ввод данных банковской карты
                            осуществляется на защищенной платежной странице <b>АО «АЛЬФА-БАНК»</b>.
                        </Text>
                    </li>
                    <li>
                        <Text>
                            На странице для ввода данных банковской карты потребуется внимательно
                            ввести номер карты, имя владельца карты, срок действия карты, трёхзначный код
                            безопасности (CVV2 для <b>VISA</b> или CVC2 для <b>MasterCard</b>).
                            Все необходимые данные пропечатаны на самой карте.
                        </Text>
                    </li>
                    <li>
                        <Text>
                            Трёхзначный код безопасности — это три цифры, находящиеся на обратной стороне карты.
                        </Text>
                    </li>
                    <li>
                        <Text>
                            Далее вы будете перенаправлены на страницу вашего банка для ввода 3DSecure-кода,
                            который придет к вам в СМС. Если 3DSecure-код вам не пришел, то следует обратится в
                            банк, выпустивший банковскую карту.
                        </Text>
                    </li>
                </div>
                <div className={ el('title') }>
                    <Text serif>Случаи отказа в совершении платежа</Text>
                </div>
                <div className={ el('text') }>
                    <li>
                        <Text>
                            банковская карта не предназначена для совершения платежей через интернет,
                            о чем можно узнать, обратившись в ваш банк;
                        </Text>
                    </li>
                    <li>
                        <Text>
                            недостаточно средств для оплаты на банковской карте. Подробнее о наличии средств на
                            банковской карте вы можете узнать, обратившись в банк, выпустивший банковскую карту;
                        </Text>
                    </li>
                    <li>
                        <Text>
                            данные банковской карты введены неверно;
                        </Text>
                    </li>
                    <li>
                        <Text>
                            истек срок действия банковской карты. Срок действия карты, как правило, указан на
                            лицевой
                            стороне карты (это месяц и год, до которого действительна карта). Подробнее о сроке
                            действия карты вы можете
                            узнать, обратившись в банк, выпустивший банковскую карту.
                        </Text>
                    </li>
                    <p>
                        <Text>
                            По вопросам оплаты с помощью банковской карты и иным вопросам, связанным с работой
                            сайта, вы
                            можете обращаться по следующему телефону: <a href={ whatsAppContacts.link }><b>{ whatsAppContacts.phone }</b></a>.
                        </Text>
                    </p>
                    <p>
                        <Text>
                            Предоставляемая вами персональная информация (имя, адрес, телефон, e-mail, номер
                            банковской карты)
                            является конфиденциальной и не подлежит разглашению. Данные вашей кредитной карты
                            передаются
                            только в зашифрованном виде и не сохраняются на нашем Web-сервере.
                        </Text>
                    </p>
                </div>
                <div className={ el('title') }>
                    <Text serif>Правила возврата денежных средств</Text>
                    <div className={ el('subtitle') } >
                        <Text serif>Для личных консультаций</Text>
                    </div>
                </div>
                <div className={ el('text', 'padding-24') }>
                    <li>
                        <Text>
                            В случае отмены и/или переноса клиентом личной консультации менее чем за 24 часа,
                            денежные
                            средства возврату не подлежат.
                        </Text>
                    </li>
                    <li>
                        <Text>
                            В случае отмены и/или переноса клиентом консультации за 24 часа и более денежные средства
                            возвращаются на карту. Период поступления денежных средств зависит от банка клиента.
                        </Text>
                    </li>
                </div>
                <div className={el('title')}>
                    <div className={el('subtitle')}>
                        <Text serif>Для online-консультаций</Text>
                    </div>
                </div>
                <div className={el('text')}>
                    <li>
                        <Text>
                            В случае отмены и/или переноса клиентом online-консультации менее чем за 12 часов,
                            денежные
                            средства возврату не подлежат.
                        </Text>
                    </li>
                    <li>
                        <Text>
                            В случае отмены и/или переноса клиентом online-консультации за 12 часов и более денежные
                            средства
                            возвращаются на карту. Период поступления денежных средств зависит от банка клиента.
                        </Text>
                    </li>
                </div>
            </div>
            <div className={ el('right-sidebar') }>
                <GiveCertWidget/>
                <BuyConsultationWidget/>
            </div>
        </Page>
    )
}

export default PaymentRules;
